import {Component, OnDestroy, OnInit} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from '../../services/authentication.service';
import {TemplateService} from '../../services/template.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-rd-send-report',
  templateUrl: './rd-send-report.component.html',
  styleUrls: ['./rd-send-report.component.scss'],
  providers: [TemplateService]
})

export class RDSendReportComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  selectedCompany: SelectItem[];
  company: any;
  selectedHomeproGroup: SelectItem[];
  homeproGroup: any;
  filterVerifiedAccount: any;
  selectedVerifiedAccount: SelectItem[];
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  allBranch = true;
  allDocType = true;
  notAccepted: any;
  branch: any;
  documentNumber: any;
  branchSuggest: any;
  typeSuggest: any;
  documentType: any;
  allDocumentType = [];
  allBranchSelected = [];
  selectedValues = [];
  test: any;
  tableData: any;
  isPageChanged: boolean;
  tableDataDisplay: any;
  statistic: any;
  modal: NgbModalRef;
  currentPage = 1;
  totalItems: number;
  loading = false;
  no_data = true;
  value = 0;
  sum_docs_count = 0;
  errorMsg = '';
  canManualResend: boolean;
  resendAllPendingMessage = '';
  monthListDropdown = [
    {label: 'มกราคม', value: 1},
    {label: 'กุมภาพันธ์', value: 2},
    {label: 'มีนาคม', value: 3},
    {label: 'เมษายน', value: 4},
    {label: 'พฤษภาคม', value: 5},
    {label: 'มิถุนายน', value: 6},
    {label: 'กรกฎาคม', value: 7},
    {label: 'สิงหาคม', value: 8},
    {label: 'กันยายน', value: 9},
    {label: 'ตุลาคม', value: 10},
    {label: 'พฤศจิกายน', value: 11},
    {label: 'ธันวาคม', value: 12}
  ];
  yearList: any[] = [];
  selectedMonth: any;
  selectedYear: any;
  defaultMonth: any;
  defaultYear: any;
  index = 0;
  uploaded_row_count: 0;
  total_rows_count: 0;
  branchList: any = null;
  selectedBranch: SelectItem[];
  allBranchList: any = null;
  docTypeList: any = null;
  loading_excel_report = false;
  sortBy: string;
  sortMode: string;
  is_TH = false;
  sortAscending = true;

  rdDocumentType: any;
  selectedRdDocumentType: any;
  selectedStatus: string;

  filterAcceptedSelected = false;
  filterRejectedSelected = false;
  filterPendingSelected = false;
  subs: Subscription;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private authService: AuthenticationService,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.isPageChanged = false;
    this.subs = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang === 'th') {
        this.is_TH = true;
      }
      if (event.lang === 'en') {
        this.is_TH = false;
      }
      this.populateDropdown();
    });
    this.populateDropdown();
    this.loadTexts();
    this.searchData();
  }

  loadInput() {
    this.company = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.selectedCompany = null;

    this.apiService.getCompany().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.company.push({
            label: obj.name,
            value: obj.id
          });
        });
      }
    );

    this.homeproGroup = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompanyGroup().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.homeproGroup.push({
            label: obj.name,
            value: obj.id
          });
        });
      }
    );

    this.apiService.getBranch().subscribe(
      (result) => {
        this.allBranchList = result;
        this.filterBranchList();
      }
    );

    // FIXME document type upon page refresh

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();
  }

  filterBranchList() {
    this.selectedBranch = null;

    this.branchList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allBranchList, (obj) => {
      if (this.selectedCompany == null || obj.corporate === this.selectedCompany) {
        this.branchList.push({
          label: obj.full_name,
          value: obj.id
        });
      }
    });
  }

  loadTexts() {
    this.translate.get('COMMON.ALL').subscribe((res: string) => {
      const documentData = this.template.getDropdown();
      this.rdDocumentType = documentData;
      documentData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};

      this.selectedRdDocumentType = null;
      this.loadInput();
    });
  }


  populateDropdown() {
    this.monthListDropdown = [];
    this.monthListDropdown.push(
      {label: this.translate.instant('MONTH.JANUARY'), value: 1},
      {label: this.translate.instant('MONTH.FEBRUARY'), value: 2},
      {label: this.translate.instant('MONTH.MARCH'), value: 3},
      {label: this.translate.instant('MONTH.APRIL'), value: 4},
      {label: this.translate.instant('MONTH.MAY'), value: 5},
      {label: this.translate.instant('MONTH.JUNE'), value: 6},
      {label: this.translate.instant('MONTH.JULY'), value: 7},
      {label: this.translate.instant('MONTH.AUGUST'), value: 8},
      {label: this.translate.instant('MONTH.SEPTEMBER'), value: 9},
      {label: this.translate.instant('MONTH.OCTOBER'), value: 10},
      {label: this.translate.instant('MONTH.NOVEMBER'), value: 11},
      {label: this.translate.instant('MONTH.DECEMBER'), value: 12}
    );
    const currentDate = new Date();
    // populate year list back within 10 years
    const thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;
    this.defaultMonth = currentDate.getMonth() + 1;
    this.defaultYear = thisYear;
  }

  canUserDownloadDoc() {
    return this.authService.isAccountantAdmin();
  }

  pageChanged() {
    this.isPageChanged = true;
    this.searchData();
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  searchBranch(event) {
    if (this.branchList == null) {
      this.apiService.getBranch().subscribe(
        (data) => {
          this.branchList = data;
          this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
        }
      );
    } else {
      this.branchSuggest = this.filterData(event.query, 'full_name', this.branchList);
    }
  }

  searchDocumentType(event) {
    if (this.docTypeList == null) {
      this.apiService.getDocumentType().subscribe(
        (result) => {
          this.docTypeList = result;
          this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
      );
    } else {
      this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
    }
  }

  filterData(query, field, dataList) {
    query = query.toLowerCase().trim();

    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      const data = dataList[i];
      if (data[field].toLowerCase().indexOf(query) >= 0) {
        filtered.push(data);
      }
    }
    return filtered;
  }

  selectAllBranch() {
    this.branch = null;
  }

  selectDocType() {
    this.documentType = null;
  }

  searchData() {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    this.allBranchSelected = [];
    this.allDocumentType = [];
    _.forEach(this.branch, (data) => {
      // this.allBranchSelected = [];
      this.allBranchSelected.push(_.toNumber(data.id));
    });
    _.forEach(this.documentType, (data) => {
      // this.allDocumentType = [];
      this.allDocumentType.push(_.toNumber(data.id));
    });
    const params = {
      no_accepted: this.notAccepted != null ? this.notAccepted : '',
      month: this.selectedMonth || '',
      year: this.selectedYear || '',
      document_number: this.documentNumber || '',
      company_id: this.selectedCompany || '',
      branch_id: this.selectedBranch ? [this.selectedBranch] : '',
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType || '',
      status: this.selectedStatus || '',
    };

    if (this.currentPage > 1) {
      params['page'] = this.currentPage;
    }

    if (this.sortBy && this.sortMode) {
      params['sort'] = this.sortBy;
      params['sort_type'] = this.sortMode;
    }

    const sniffTargetArr: string[] = [];
    if (this.documentNumber) {
      sniffTargetArr.push('FILTER.DOCUMENT-NUMBER');
    }

    if (this.selectedRdDocumentType) {
      sniffTargetArr.push('FILTER.DOCUMENT-TYPE');
    }

    if (this.defaultMonth !== this.selectedMonth) {
      sniffTargetArr.push('FILTER.MONTH');
    }

    if (this.defaultYear !== this.selectedYear) {
      sniffTargetArr.push('FILTER.YEAR');
    }

    if (this.notAccepted) {
      sniffTargetArr.push('RD-SEND-REPORT.ONLY-NO-ACCEPTED');
    }

    this.apiService.getRDSendReport(params).subscribe(
      (result) => {

        // Check if result object is empty
        if (Object.keys(result).length != 0 || result.constructor != Object) {
          this.loading = false;
          this.tableData = result.results;
          this.tableDataDisplay = this.tableData;
          this.no_data = _.isEmpty(this.tableData);
          this.totalItems = result.count;
          this.statistic = result.statistic;

          this.selectedValues = [];
          for (let i = 0; i < this.tableData.length; i++) {
            this.selectedValues.push(false);
          }
        }
      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    );
    this.getLatestManualResendTime();

    if (!this.isPageChanged) {
      const sniffTarget = sniffTargetArr.join(', ');
      this.sniff('SEARCH', sniffTarget);
    }
  }

  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.selectedStatus = null;
    this.searchData();
  }

  searchStatus(status: string) {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    this.selectedStatus = status;
    this.searchData();
  }

  getLatestManualResendTime() {
    const data = {
      month: this.selectedMonth,
      year: this.selectedYear,
    };
    this.apiService.getLatestManualResendTime(data).subscribe(
      (result) => {
        this.canManualResend = result.can_manual_resend;
      },
      error => {
        console.log('error', error);
      }
    );
  }

  closeResendAllPending() {
    this.modal.close();
    this.searchButtonClicked();
  }

  resendAllPending(content) {
    const data = {
      month: this.selectedMonth,
      year: this.selectedYear,
    };
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
    this.apiService.resendAllPendingEbxml(data).subscribe(
      (res: any) => {
        this.resendAllPendingMessage = res.msg;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  clearData() {
    this.startDate = new Date();
    this.endDate = new Date();
    this.selectedMonth = this.defaultMonth;
    this.selectedYear = this.defaultYear;
    this.selectedCompany = null;
    this.selectedVerifiedAccount = null;
    this.selectedHomeproGroup = null;
    this.branch = null;
    this.documentNumber = null;
    this.documentType = null;
    this.allDocType = true;
    this.allBranch = true;
    this.notAccepted = false;
    this.selectedBranch = null;
    this.selectedRdDocumentType = null;

    this.searchButtonClicked();
  }

  clearBranch() {
    this.allBranchSelected = [];
  }

  clearDocType() {
    this.allDocumentType = [];
  }

  checkCondition() {
    this.errorMsg = '';

    const errorMsgList = [];
    if (_.isEmpty(this.branch) && this.allBranch === false) {
      errorMsgList.push(this.translate.instant('FILTER.BRANCH'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' +
        this.translate.instant('COMMON.CORRECT');
    }
  }

  DownloadExcelReport() {
    this.loading_excel_report = true;

    // const params = {
    //   month: this.selectedMonth,
    //   year: this.selectedYear,
    // };
    // this.apiService.getExcelReport(params).subscribe(
    //   (obj) => {
    //     const filename = 'tax_report_' + this.selectedMonth + '_' + this.selectedYear  + '.xlsx';
    //     this.apiService.createDownloadFile(obj, filename);
    //     this.loading_excel_report = false;
    //   },
    //   error => {
    //     this.loading_excel_report = false;
    //   }
    // );

    this.loading_excel_report = false;
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }

    // this.searchData();
  }

  // resend function is not used now
  resend(taxDataId: number) {
    this.apiService.resendToRD(taxDataId).subscribe(
      (res: any) => {
        this.searchData();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  filterAccepted() {
    if (this.filterAcceptedSelected === false) {
      this.filterAcceptedSelected = true;
      this.searchStatus('rd_accepted');
    } else {
      this.filterAcceptedSelected = false;
      this.searchStatus(null);
    }
  }

  filterRejected() {
    if (this.filterRejectedSelected === false) {
      this.filterRejectedSelected = true;
      this.searchStatus('rd_rejected');
    } else {
      this.filterRejectedSelected = false;
      this.searchStatus(null);
    }
  }

  filterPending() {
    if (this.filterPendingSelected === false) {
      this.filterPendingSelected = true;
      this.searchStatus('sent_to_service_provider');
    } else {
      this.filterPendingSelected = false;
      this.searchStatus(null);
    }
  }

  sortColumn(columnName) {
    if (this.sortAscending) {
      this.sortAscending = false;
      this.tableDataDisplay = this.tableData.sort(function (a, b) {

        // handle null value
        if (a[columnName] !== null && b[columnName] === null) {
          return 1;
        }
        if (a[columnName] === null && b[columnName] !== null) {
          return -1;
        }
        if (a[columnName] === null && b[columnName] === null) {
          return 0;
        }

        // handle status Accepted, Rejected, and Pending
        if (columnName === 'ebxml_status') {
          // Accepted vs. Accepted
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_accepted') {
            return 0;
          }
          // Accepted vs. Pending
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'sent_to_service_provider') {
            return 1;
          }
          // Accepted vs. Error
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_error') {
            return 1;
          }
          // Accepted vs. Ack
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_acknowledged') {
            return 1;
          }
          // Accepted vs. Rejected
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_rejected') {
            return 1;
          }
          // Pending vs Accepted
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_accepted') {
            return -1;
          }
          // Pending vs Error
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_error') {
            return -1;
          }
          // Pending vs Ack
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_acknowledged') {
            return -1;
          }
          // Pending vs Pending
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'sent_to_service_provider') {
            return 0;
          }
          // Pending vs Rejected
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_rejected') {
            return 1;
          }
          // Rejected vs Accepted
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_accepted') {
            return -1;
          }
          // Rejected vs Pending
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'sent_to_service_provider') {
            return 1;
          }
          // Rejected vs Error
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_error') {
            return 1;
          }
          // Rejected vs Ack
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_acknowledged') {
            return 1;
          }
          // Rejected vs Rejected
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_rejected') {
            return 0;
          }
          // Error vs Accepted
          if (a[columnName] === 'rd_error' && b[columnName] === 'rd_accepted') {
            return -1;
          }
          // Error vs Pending
          if (a[columnName] === 'rd_error' && b[columnName] === 'sent_to_service_provider') {
            return 1;
          }
          // Error vs Error
          if (a[columnName] === 'rd_error' && b[columnName] === 'rd_error') {
            return 0;
          }
          // Error vs Ack
          if (a[columnName] === 'rd_error' && b[columnName] === 'rd_acknowledged') {
            return -1;
          }
          // Error vs Rejected
          if (a[columnName] === 'rd_error' && b[columnName] === 'rd_rejected') {
            return -1;
          }
          // Ack vs Accepted
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_accepted') {
            return -1;
          }
          // Ack vs Pending
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'sent_to_service_provider') {
            return 1;
          }
          // Ack vs Error
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_error') {
            return 1;
          }
          // Ack vs Ack
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_acknowledged') {
            return 0;
          }
          // Ack vs Rejected
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_rejected') {
            return -1;
          }
        }

        // handle RD Acknowledge and Sent to SP
        if (columnName === 'rd_acknowledged' || columnName === 'sent_to_rd') {
          return a['ebxml_steps'][columnName] < b['ebxml_steps'][columnName] ? -1 : a['ebxml_steps'][columnName] > b['ebxml_steps'][columnName] ? 1 : 0;
        }

        return a[columnName] < b[columnName] ? -1 : a[columnName] > b[columnName] ? 1 : 0;
      });
    } else {
      this.sortAscending = true;
      this.tableDataDisplay = this.tableData.sort(function (a, b) {

        // handle null value
        if (a[columnName] !== null && b[columnName] === null) {
          return -1;
        }
        if (a[columnName] === null && b[columnName] !== null) {
          return 1;
        }
        if (a[columnName] === null && b[columnName] === null) {
          return 0;
        }

        // handle status Accepted, Rejected, and Pending
        if (columnName === 'ebxml_status') {
          // Accepted vs. Accepted
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_accepted') {
            return 0;
          }
          // Accepted vs. Pending
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'sent_to_service_provider') {
            return -1;
          }
          // Accepted vs. Error
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_error') {
            return -1;
          }
          // Accepted vs. Ack
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_acknowledged') {
            return -1;
          }
          // Accepted vs. Rejected
          if (a[columnName] === 'rd_accepted' && b[columnName] === 'rd_rejected') {
            return -1;
          }
          // Pending vs Accepted
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_accepted') {
            return 1;
          }
          // Pending vs Error
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_error') {
            return 1;
          }
          // Pending vs Ack
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_acknowledged') {
            return 1;
          }
          // Pending vs Pending
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'sent_to_service_provider') {
            return 0;
          }
          // Pending vs Rejected
          if (a[columnName] === 'sent_to_service_provider' && b[columnName] === 'rd_rejected') {
            return -1;
          }
          // Rejected vs Accepted
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_accepted') {
            return 1;
          }
          // Rejected vs Pending
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'sent_to_service_provider') {
            return -1;
          }
          // Rejected vs Error
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_error') {
            return -1;
          }
          // Rejected vs Ack
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_acknowledged') {
            return -1;
          }
          // Rejected vs Rejected
          if (a[columnName] === 'rd_rejected' && b[columnName] === 'rd_rejected') {
            return 0;
          }
          // Error vs Accepted
          if (a[columnName] === 'rd_error' && b[columnName] === 'rd_accepted') {
            return 1;
          }
          // Error vs Pending
          if (a[columnName] === 'rd_error' && b[columnName] === 'sent_to_service_provider') {
            return -1;
          }
          // Error vs Error
          if (a[columnName] === 'rd_error' && b[columnName] === 'rd_error') {
            return 0;
          }
          // Error vs Ack
          if (a[columnName] === 'rd_error' && b[columnName] === 'rd_acknowledged') {
            return 1;
          }
          // Error vs Rejected
          if (a[columnName] === 'rd_error' && b[columnName] === 'rd_rejected') {
            return 1;
          }
          // Ack vs Accepted
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_accepted') {
            return 1;
          }
          // Ack vs Pending
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'sent_to_service_provider') {
            return -1;
          }
          // Ack vs Error
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_error') {
            return -1;
          }
          // Ack vs Ack
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_acknowledged') {
            return 0;
          }
          // Ack vs Rejected
          if (a[columnName] === 'rd_acknowledged' && b[columnName] === 'rd_rejected') {
            return 1;
          }
        }

        // handle RD Acknowledge and Sent to SP
        if (columnName === 'rd_acknowledged' || columnName === 'sent_to_rd') {
          return a['ebxml_steps'][columnName] < b['ebxml_steps'][columnName] ? 1 : a['ebxml_steps'][columnName] > b['ebxml_steps'][columnName] ? -1 : 0;
        }

        return a[columnName] < b[columnName] ? 1 : a[columnName] > b[columnName] ? -1 : 0;
      });
    }
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'RD_SUMMARY',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report.component.ts